import Vue from 'vue';
import Router from 'vue-router';
import Principal from '@/components/Main.vue';
import { storeInstance } from '@/store';
import * as AuthService from '@/services/AuthService.js';

Vue.use(Router);
let routesArray = [
  {
    path: '/',
    redirect: { name: 'inicio' },
    name: 'DefaultInicio',
    component: Principal,
    children: [
      {
        path: '/inicio',
        name: 'inicio',
        component: () => import('@/components/Principal/views/Inicio.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false
        }
      },
      {
        path: '/ods',
        name: 'ods',
        component: () => import('@/components/Ods/views/Ods.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false,
          breadcrumb: [
            { name: 'Objetivos Desarrollo Sostenible' }
          ]
        }
      },
      {
        path: '/plan-accion',
        name: 'plan-accion',
        component: () => import('@/components/PlanAccion/views/PlanAccion.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false,
          breadcrumb: [
            { name: 'Mi Agenda Urbana: Plan de acción' }
          ]
        }
      },
      {
        path: '/vista-general/plan-accion',
        name: 'vista-general/plan-accion',
        component: () => import('@/components/PlanAccion/views/PlanAccion.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false,
          breadcrumb: [
            { name: 'Mi Agenda Urbana: Vista General', link: '/vista-general' },
            { name: 'Mi Agenda Urbana: Plan de acción' }
          ]
        }
      },
      {
        path: 'plan-accion/vista-general',
        name: 'plan-accion/vista-general',
        component: () => import('@/components/Aue/views/Aue.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false,
          breadcrumb: [
            { name: 'Mi Agenda Urbana: Plan de acción', link: '/plan-accion' },
            { name: 'Mi Agenda Urbana: Vista General' }
          ]
        }
      },
      {
        path: '/vista-general',
        name: 'vista-general',
        component: () => import('@/components/Aue/views/Aue.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: true,
          breadcrumb: [
            { name: 'Mi Agenda Urbana: Vista General' }
          ]
        }
      },
      {
        path: '/diagnostico',
        name: 'diagnostico',
        component: () => import('@/components/Diagnostico/views/Diagnostico.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: false,
          breadcrumb: [
            { name: 'Mi Agenda Urbana: Diagnóstico' }
          ]
        }
      },
      {
        path: '/indices-tematicos/:idIndiceTematico?',
        name: 'indices-tematicos',
        component: () => import('@/components/Indicadores/views/Listado.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: true,
          breadcrumb: [
            { name: 'Observatorio de indicadores' }
          ]
        }
      },
      {
        path: '/indicadores/:idIndicador/:idRelacionAUE?',
        name: 'detalle_indicador',
        component: () => import('@/components/Indicadores/views/Detalle.vue'),
        meta: {
          access: true,
          admin: false,
          gestor: true,
          ciudadano: true,
          breadcrumb: [
            { name: 'Indices Temáticos', link: '/indices-tematicos' },
            { name: 'Detalle indicador' }
          ]
        },
        props: true
      },
      {
        path: '/indicadoresAUE/:idCiudadIndicadorAUE/:tipo/:nameLink/:link',
        name: 'detalle_indicador_aue',
        component: () => import('@/components/Indicadores/views/DetalleIndicadorAUE.vue'),
        meta: (route) => ({
          access: true,
          admin: false,
          gestor: true,
          ciudadano: true,
          breadcrumb: [
            { name: route.params.nameLink !== undefined ? route.params.nameLink : 'Mi Agenda Urbana: Vista General', link: route.params.link !== undefined ? route.params.link : '/vista-general' },
            { name: 'Detalle indicador' }
          ]
        }),
        props: true
      },
      {
        path: '/administracion/ciudades',
        name: 'ciudades',
        component: () => import('@/components/Ciudades/views/ListadoCiudades.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de municipios' }
          ]
        }
      },
      {
        path: '/administracion/ciudades/editar/:idCiudad',
        name: 'form_edit_ciudades',
        component: () => import('@/components/Ciudades/views/EdicionCiudades.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de municipios', link: '/administracion/ciudades' },
            { name: 'Editar municipio' }
          ]
        }
      },
      {
        path: '/administracion/ciudades/nuevo',
        name: 'form_new_ciudad',
        component: () => import('@/components/Ciudades/views/EdicionCiudades.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de municipios', link: '/administracion/ciudades' },
            { name: 'Crear nuevo municipio' }
          ]
        }
      },
      {
        path: '/administracion/indicadores',
        name: 'admin_indicadores',
        component: () => import('@/components/Indicadores/views/AdminListado.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de Indicadores' }
          ]
        }
      },
      {
        path: '/administracion/aue',
        name: 'admin_aue',
        component: () => import('@/components/Aue/views/AdminAue.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de Agenda Española' }
          ]
        }
      },
      {
        path: '/administracion/indices-tematicos',
        name: 'admin_indicestematicos',
        component: () => import('@/components/IndicesTematicos/views/IndicesTematicosListado.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de índices temáticos' }
          ]
        }
      },
      {
        path: '/administracion/indices-tematicos/nuevo',
        name: 'form_new_indice_tematico',
        component: () => import('@/components/IndicesTematicos/views/IndicesTematicosEdicion.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de índices temáticos', link: '/administracion/indices-tematicos' },
            { name: 'Nuevo índice temático' }
          ]
        }
      },
      {
        path: '/administracion/indices-tematicos/editar/:idIndiceTematico',
        name: 'form_edit_indice_tematico',
        component: () => import('@/components/IndicesTematicos/views/IndicesTematicosEdicion.vue'),
        meta: {
          access: true,
          admin: true,
          gestor: false,
          ciudadano: false,
          breadcrumb: [
            { name: 'Administración de índices temáticos', link: '/administracion/indices-tematicos' },
            { name: 'Edición índice temático' }
          ]
        }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/shared/error-pages/components/404.vue')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/shared/error-pages/components/401.vue')
  }
];

const routes = new Router({
  base: process.env.VUE_APP_URL,
  mode: 'history',
  routes: routesArray,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

routes.beforeEach(async (to, from, next) => {
  await storeInstance.restored;
  const { access, admin, ciudadano } = to.meta;
  const isMunicipioMode = typeof window !== 'undefined' && window.location && window.location.href.indexOf('IdMunicipio') !== -1;
  // Si venimos en modo municipio permitimos el acceso sin autenticación
  if (isMunicipioMode) {
    if (to.name === 'inicio' || to.path === '/') {
      return next({ name: 'indices-tematicos', query: to.query });
    }
    return next();
  }

  // Página anonima no comprobamos nada
  if (to.matched.some(record => record.meta.AllowAnonymous)) {
    next();
  } else {
    // ¿No está autorizado? Login
    if (!AuthService.authenticated()) {
      // Hacemos login
      AuthService.login();
    } else {
      // Página que necesita login autorización (User)
      if (access) {
        // Se ha conseguido autorizar en la aplicacion?
        await AuthService.setData();
        if (!storeInstance.getters['NGUD/isAuthIn']) return next('401');
        // Comprobamos que el usuario tenga rol access
        if (!storeInstance.getters['NGUD/haveAccess']) return next('401');
        // ¿la pagina necesita rol diferente a ciudadano?
        if (to.name === 'inicio' && storeInstance.getters['NGUD/isCiudadano']) {
          return next('indices-tematicos');
        } else if (!ciudadano && storeInstance.getters['NGUD/isCiudadano']) {
          return next('401');
        }
        // ¿La página necesita rol de Admin? ¿Es admin?
        if (admin && !storeInstance.getters['NGUD/isAdmin']) return next('401');

        return next();
      } else {
        // Página privada que no necesita autorización (Admin)
        next();
      }
    }
  }
});

export default routes;
